import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils.ts'

const navLinkVariants = cva(
  'inline-flex cursor-pointer select-none items-start justify-center gap-2.5 rounded-corner border-[6px] border-solid px-3.5 py-1.5 text-base disabled:pointer-events-none disabled:border-gray-50 disabled:bg-gray-50 disabled:text-gray-300',
  {
    variants: {
      state: {
        default:
          'border-gray-200 bg-gray-50 text-gray-800 hover:border-blue-200 active:border-blue-200 active:bg-blue-100',
        active: 'border-blue-600 bg-blue-100 font-bold',
        disabled: '',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
)

export interface NavLinkProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof navLinkVariants> {}

export const NavLink = React.forwardRef<HTMLButtonElement, NavLinkProps>(({ className, state, ...props }, ref) => (
  <button type="button" className={cn(navLinkVariants({ state, className }))} ref={ref} {...props} />
))
